export default "__VITE_ASSET__CS_6iJAn__"